import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import clsx from "clsx";
import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";
import colors from "tailwindcss/colors";

interface StyledInputDateProps<FieldsType extends FieldValues> {
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  control: Control<FieldsType>;
  name: Path<FieldsType>;
  defaultValue?: PathValue<FieldsType, Path<FieldsType>>;
  minDate?: Date;
}

const StyledInputDate = <FieldsType extends FieldValues>({
  className,
  control,
  name,
  defaultValue,
  minDate,
}: StyledInputDateProps<FieldsType>) => {
  return (
    <div className={clsx("flex flex-col gap-2", className)}>
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({ field }) => (
          <DatePicker
            {...field}
            minDate={minDate}
            sx={{
              ".MuiInputBase-root": {
                border: "none",
                height: "2.5rem",
                borderRadius: "0.5rem",
                color: colors.gray[500],
                borderColor: colors.gray[200],
                backgroundColor: colors.white,
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: colors.gray[200],
                },
                "&:hover fieldset": {
                  borderColor: colors.gray[300],
                },
              },
            }}
          />
        )}
      />
    </div>
  );
};

export default StyledInputDate;
